// extracted by mini-css-extract-plugin
export default {"popoverRoot":"MenuPopover_popoverRoot__1kPhl","popoverPaper":"MenuPopover_popoverPaper__12vjT"};